export var convertToUpdateDto = function (data) {
    var dtoData = {
        name: data.name,
    };
    return dtoData;
};
